import TemplateContents from './TemplateContents';
import { gsap } from 'gsap';
import lottie from "lottie-web/build/player/lottie_svg";

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
    if (this.container) {
      this.container.removeEventListener('mousedown', this.onDragStart);
      this.container.removeEventListener('touchstart', this.onDragStart);
    }
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('touchmove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);
    document.removeEventListener('touchend', this.onDragEnd);
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.lottieAnim) {
      this.lottieAnim.destroy();
      this.lottieAnim = null;
    }
  }

  setVars() {
    super.setVars();
    this.isDragging = false;
    this.startX = 0;
    this.startTranslate = 0;
    this.currentX = 0;
    this.targetX = 0;
    this.itemWidth = 0;
    this.totalWidth = 0;
    this.lerpFactor = 0.1;
    this.imageCount = 32; // 画像の総数
    this.itemsPerList = 7; // 各リストに表示するアイテム数
    this.isVisible = false;
    this.lottieAnim = null;
    this.arrowLoopTween = null;

    this.onDragStart = this.onDragStart.bind(this);
    this.onDragMove = this.onDragMove.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  setDom() {
    super.setDom();
    this.container = document.querySelector('main.top .section5 .content2');
    if (!this.container) return;

    this.scroller = this.container.querySelector('.scroller');
    if (!this.scroller) return;

    this.listAll = this.scroller.querySelectorAll('.desire_list');
    this.listInnerAll = this.scroller.querySelectorAll('.desire_list .desire_list_inner');

    this.lottieContainer = document.getElementById('lottie-container_yoku');
    
    this.yokuBtn = document.querySelector('main.top .section5 > .btn a');
    this.section5ArrowAll = document.querySelectorAll('main.top .section5 h2 .arrows .arrow');
    this.section5Arrows = document.querySelector('main.top .section5 h2 .arrows');
  }

  initEvents() {
    super.initEvents();

    this.pack.applyIconHoverEffect(this.yokuBtn, this.yokuBtn);

    // 矢印のホバーアニメーション (PCのみ)
    if (!this.pack.hasTouch && this.section5ArrowAll) {
      this.section5ArrowAll.forEach(arrow => {
        const inner = arrow.querySelector('.arrow_inner');
        arrow.addEventListener('mouseenter', () => {
          if (!inner || gsap.isTweening(inner)) return;
          gsap.to(inner, {
            keyframes: [
              { rotationY: 360, y: 13, duration: 0.25, ease: "linear.in" },
              { rotationY: 0, y: 0, duration: 0.25, ease: "quart.out" }
            ],
            overwrite: true
          });
        });
      });
    }

    if (!this.container) return;

    this.container.addEventListener('mousedown', this.onDragStart);
    this.container.addEventListener('touchstart', this.onDragStart, { passive: false });

    document.addEventListener('mousemove', this.onDragMove);
    document.addEventListener('touchmove', this.onDragMove, { passive: false });

    document.addEventListener('mouseup', this.onDragEnd);
    document.addEventListener('touchend', this.onDragEnd);
  }

  start() {
    this.setupRandomList();
    this.initObserver();
    this.initLottie();

    // 矢印にランダムな色クラスを付与
    if (this.section5ArrowAll) {
      for (let i = 0, len = this.section5ArrowAll.length; i < len; i++) {
        let arrow = this.section5ArrowAll[i];
        let inner = arrow.querySelector('.arrow_inner');
        const randomNum = Math.floor(Math.random() * 7) + 1;
        if (inner) inner.classList.add(`color${randomNum}`);
      }
    }
  }

  startArrowLoop() {
    if (!this.section5ArrowAll || this.section5ArrowAll.length === 0) return;
    
    this.stopArrowLoop();

    this.arrowLoopTween = gsap.to(this.section5ArrowAll, {
      keyframes: [
        { rotationY: 360, y: 13, duration: 0.55, ease: "quart.in" },
        { rotationY: 0, y: 0, duration: 0.55, ease: "quart.out", delay: 0.05 }
      ],
      stagger: {
        each: 0.05,
        from: "start",
      },
      repeat: -1,
      repeatDelay: 1
    });
  }

  stopArrowLoop() {
    if (this.arrowLoopTween) {
      this.arrowLoopTween.kill();
      this.arrowLoopTween = null;
    }
    if (!this.section5ArrowAll) return;
    gsap.killTweensOf(this.section5ArrowAll);
    // 停止時は初期位置に戻す
    gsap.set(this.section5ArrowAll, { rotationY: 0, y: 0 });
  }

  initLottie() {
    if (!this.lottieContainer) return;

    this.lottieAnim = lottie.loadAnimation({
      container: this.lottieContainer,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: this.pack.ASSETS_PATH + 'lottie/yoku/data.json'
    });
  }

  initObserver() {
    if (!this.container) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === this.container) {
          this.isVisible = entry.isIntersecting;
        } else if (entry.target === this.section5Arrows) {
          if (entry.isIntersecting) {
            this.startArrowLoop();
          } else {
            this.stopArrowLoop();
          }
        }
      });
    }, { rootMargin: '0px' }); // 画面に入る少し前から動かす
    this.observer.observe(this.container);
    if (this.section5Arrows) this.observer.observe(this.section5Arrows);
  }

  onDragStart(e) {
    this.isDragging = true;
    this.startX = e.pageX || e.touches[0].pageX;
    this.startTranslate = this.targetX;
    this.container.style.cursor = 'grabbing';

    // ドラッグ開始時は慣性を切って追従させる
    this.currentX = this.targetX;
    gsap.set(this.scroller, { x: this.currentX });
  }

  onDragMove(e) {
    if (!this.isDragging) return;
    const currentX = e.pageX || e.touches[0].pageX;
    const distance = currentX - this.startX;
    this.targetX = this.startTranslate + distance;
  }

  onDragEnd() {
    this.isDragging = false;
    if (this.container) {
      this.container.style.cursor = 'grab';
    }
  }

  setupRandomList() {
    if (!this.listAll || this.listAll.length === 0) return;

    const imageSources = [];
    for (let i = 1; i <= this.imageCount; i++) {
      imageSources.push(`${this.pack.ASSETS_PATH}img/top/yoku/yoku-${i}.svg`);
    }

    let loadedCount = 0;
    const totalImages = this.listAll.length * (this.itemsPerList * 2);

    this.listAll.forEach(listElement => {
      let inner = listElement.querySelector('.desire_list_inner');
      inner.innerHTML = '';

      //配列のシャッフル
      const baseSources = this.shuffleArray(imageSources).slice(0, this.itemsPerList);
      //配列1つ分をもう一つお尻に追加
      const shuffledSources = [...baseSources, ...baseSources];
      // trace(shuffledSources);

      shuffledSources.forEach(src => {
        const li = document.createElement('li');
        const img = document.createElement('img');
        img.onload = () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            this.executeResize();
          }
        };
        img.src = src;
        img.alt = '';
        li.appendChild(img);
        inner.appendChild(li);
      });
    });
  }

  shuffleArray(array) {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  }

  scrollHandler() {}

  enterframe() {
    if (!this.scroller) return;
    if (!this.isVisible) return;

    if (!this.itemWidth && this.listAll && this.listAll.length > 0 && this.listAll[0].offsetWidth > 0) {
      this.executeResize();
    }

    if (!this.itemWidth || !this.totalWidth) return;

    this.currentX += (this.targetX - this.currentX) * this.lerpFactor;

    // コンテナを動かす
    gsap.set(this.scroller, { x: this.currentX });

    // インナーリストの縦スライド
    if (this.listInnerAll) {
      this.listInnerAll.forEach((el, i) => {
        if (!el._halfHeight) return;

        const isEven = i % 2 === 0;
        if (el._scrollY === undefined) el._scrollY = isEven ? 0 : -el._halfHeight;

        if (isEven) {
          el._scrollY -= 1.2;
          if (el._scrollY <= -el._halfHeight) el._scrollY += el._halfHeight;
        } else {
          el._scrollY += 1.2;
          if (el._scrollY >= 0) el._scrollY -= el._halfHeight;
        }

        gsap.set(el, { y: el._scrollY });
      });
    }

    // コンテナの画面中央からのズレを計算（パララックス用）
    const rect = this.container.getBoundingClientRect();
    const centerDiff = (rect.top + rect.height * 0.5) - (window.innerHeight * 0.5);

    // 各リストのループ処理
    this.listAll.forEach((item, i) => {
      if (item._x === undefined) return;

      const visualX = this.currentX + item._x;

      // 左端から出て画面外に移動した場合、右端に移動させる
      if (visualX + this.itemWidth < 0) {
        item._x += this.totalWidth;
      }

      // 右端から出て画面外に移動した場合、左端に移動させる
      if (visualX > this.sw) {
        item._x -= this.totalWidth;
      }

      gsap.set(item, { x: item._x });
    });
  }

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
    if (this.listAll && this.listAll.length > 0) {
      if (this.scroller) this.scroller.style.position = 'relative';

      const item = this.listAll[0];
      
      this.listAll.forEach(el => {
        el.style.position = 'absolute';
        el.style.top = '0';
        el.style.left = '0';
      });

      const style = window.getComputedStyle(item);
      const marginLeft = parseFloat(style.marginLeft) || 0;
      const marginRight = parseFloat(style.marginRight) || 0;

      this.itemWidth = item.offsetWidth + marginLeft + marginRight;
      this.totalWidth = this.itemWidth * this.listAll.length;

      // 各要素の初期位置を設定
      this.listAll.forEach((el, i) => {
        el._x = i * this.itemWidth;
        gsap.set(el, { x: el._x });
      });

      if (this.listInnerAll) {
        this.listInnerAll.forEach(el => {
          el._halfHeight = el.offsetHeight / 2;
        });
      }
    }
  }
}
